export default {
  path: "/moduleMain",
  meta: {
    title: "公共路由",
  },
  component: () => import("../views/common/moduleMain.vue"),
  children: [
    {
      path: "/home",
      meta: {
        title: "首页",
        isTransparent: true,
        naveInd: 0,
      },
      component: () => import("../views/main/home.vue"),
    },
    {
      path: "/down",
      meta: {
        title: "下载客户端",
        naveInd: 1,
      },
      component: () => import("../views/main/downLoad.vue"),
    },
    {
      path: "/detail",
      meta: {
        title: "下载客户端",
      },
      component: () => import("../views/main/article.vue"),
    },
    {
      path: "/honorary_awards/:menuId",
      meta: {
        title: "荣誉奖项",
        contentType: "c-4",
        sortType: "s-251",
      },
      component: () => import("../views/main/honoraryAwards.vue"),
    },
    {
      path: "/recruit",
      meta: {
        title: "人才招聘",
      },
      component: () => import("../views/main/recruit.vue"),
    },
    {
      path: "/paper_detail",
      meta: {
        title: "模拟测试",
      },
      component: () => import("../views/main/paperDetail.vue"),
    },
    {
      path: "/contact_us/:menuId",
      meta: {
        title: "联系我们",
        contentType: "c-3",
        sortType: "s-12",
      },
      component: () => import("../views/main/contactUs.vue"),
    },
  ],
};
